import React, { Component } from "react";
import PropTypes from "prop-types";

import "css/Autocomplete.css";

class Autocomplete extends Component {
    static propTypes = {
        suggestions: PropTypes.instanceOf(Array)
    };

    static defaultProps = {
        suggestions: []
    };

    constructor(props) {
        super(props);

        this.state = {
            showSuggestions: false
        };
    }

    render() {
        const { suggestions, value, onChange, ...other } = this.props;
        const { showSuggestions } = this.state;

        return (
            <div className="autocomplete">
                <input
                    {...other}
                    ref={el => (this.inputRef = el)}
                    type="text"
                    onChange={onChange}
                    value={value}
                    onFocus={() => this.setState({ showSuggestions: true })}
                    onBlur={() => setTimeout(() => this.setState({ showSuggestions: false }), 200)}
                />
                {showSuggestions && (
                    <div className="autocomplete__suggestions">
                        {suggestions.map((suggestion, index) => (
                            <div
                                key={suggestion}
                                onClick={() => {
                                    onChange(suggestion);
                                    setTimeout(() => this.inputRef.blur(), 200);
                                }}
                            >
                                {suggestion}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default Autocomplete;



// WEBPACK FOOTER //
// ./src/components/Autocomplete.js